import * as React from 'react'

import { Text, Box } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const Done = () => {
  return (
    <>
      <Text.Header2>
        {i18n.t('payroll_integrations.incidences.a3innuva.contract_deactivation.done.title')}
      </Text.Header2>
      <Box gap="s16">
        {i18n.t('payroll_integrations.incidences.a3innuva.contract_deactivation.done.message')}
      </Box>
    </>
  )
}

export default Done
